const BlogsSection = () => {
    return (
        <div className="space-y-6">
            <h2 className="text-2xl font-bold text-slate-900">📖 Bài Học Lý Thuyết</h2>
            <p className="text-slate-700">
                Đọc các bài giảng, tài liệu lý thuyết do giáo viên cung cấp.
            </p>

            <div className="bg-white p-6 rounded-lg border border-slate-200">
                <h3 className="text-lg font-semibold text-slate-900 mb-4">Nội dung bài học:</h3>
                <ul className="text-slate-700 space-y-3">
                    <li className="flex items-start gap-3">
                        <span className="text-2xl">📚</span>
                        <div>
                            <strong>Bài giảng lý thuyết:</strong> Các khái niệm, công thức, định lý quan trọng
                        </div>
                    </li>
                    <li className="flex items-start gap-3">
                        <span className="text-2xl">✍️</span>
                        <div>
                            <strong>Ví dụ minh họa:</strong> Bài tập mẫu có lời giải chi tiết
                        </div>
                    </li>
                    <li className="flex items-start gap-3">
                        <span className="text-2xl">🖼️</span>
                        <div>
                            <strong>Hình ảnh & đồ thị:</strong> Hình minh họa giúp dễ hiểu
                        </div>
                    </li>
                    <li className="flex items-start gap-3">
                        <span className="text-2xl">📐</span>
                        <div>
                            <strong>Công thức toán học:</strong> Render đẹp với LaTeX/KaTeX
                        </div>
                    </li>
                </ul>
            </div>

            <div className="bg-green-50 p-6 rounded-lg border border-green-200">
                <h3 className="text-lg font-semibold text-green-900 mb-2">💡 Cách học hiệu quả</h3>
                <ol className="text-slate-700 space-y-2 list-decimal list-inside">
                    <li>Đọc kỹ lý thuyết trước khi làm bài tập</li>
                    <li>Ghi chép các công thức, định lý quan trọng</li>
                    <li>Làm các ví dụ mẫu để hiểu cách áp dụng</li>
                    <li>Hỏi AI nếu có phần nào chưa rõ</li>
                    <li>Thực hành với bài tập để củng cố kiến thức</li>
                </ol>
            </div>
        </div>
    );
};

export default BlogsSection;
